import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { NavigationService } from "../../../services/navigation/navigation.service";

@Component({
	selector: "tig-company-lookup",
	templateUrl: "./company-lookup.template.html"
})
export class CompanyLookupComponent {
	public companyKey: string = "";
	public loading: boolean = false;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private http: HttpClient,
		private toastr: ToastrService,
		private navigationService: NavigationService
	) {}

	searchAndCreate(): void {
		var key = (this.companyKey || "").trim();
		if (!key) {
			this.toastr.error("Bitte Kundennummer oder BA-ID eingeben");
			return;
		}

		var parent = this.route.parent;
		var routeMenu = parent ? parent.snapshot.paramMap.get("route_menu") : "company";
		if (!routeMenu) {
			routeMenu = "company";
		}

		var endpoint = this.navigationService.getDataEndpointByRoute(routeMenu, "companies", null, false);
		var params: HttpParams = this.navigationService.getDataEndpointParamsByRoute(routeMenu, "companies");
		params = params.set("lookup", "true").set("create", "true");

		this.loading = true;

		this.http.get<any>(endpoint + "/" + encodeURIComponent(key), { params: params }).subscribe(
			(res) => {
				this.loading = false;

				var id = res && res.id ? res.id : null;
				var url = res && res.url ? res.url : null;

				if (url) {
					this.router.navigateByUrl(url);
					return;
				}

				if (id) {
					this.router.navigate([routeMenu, "companies", id], { queryParams: this.route.snapshot.queryParams });
					return;
				}

				this.toastr.error("Unerwartete Antwort vom Server");
			},
			(err) => {
				this.loading = false;
				var msg =
					err && err.error && err.error.detail
						? err.error.detail
						: "Fehler bei der Suche/Anlage";
				this.toastr.error(msg);
			}
		);
	}
}
